module.exports = __webpack_public_path__ + "img/tools_economy_banner.519e0330.jpg";